module.exports = __webpack_public_path__ + "img/adv2.c0bcdbc1.svg";